import toastr from 'toastr';
import {SuccessResponse} from '../../../domain';

const timeout = 15000;
toastr.options.timeOut = timeout;
toastr.options.extendedTimeOut = timeout;

function escapeHtml(value: string) {
  return value
    .replace('&', '&amp;')
    .replace('<', '&lt;')
    .replace('>', '&gt;')
    .replace('"', '&quot;')
    .replace('\'', '&#039;');
}

function success(response: SuccessResponse) {
  if (!(Array.isArray(response.Successes) && response.Successes.length > 0))
    return;
  let paragraphs: string[] = [];
  for (let success of response.Successes)
    if (typeof success.Message === 'string' && success.Message !== '')
      paragraphs.push(`<div>${escapeHtml(success.Message)}</div>`);
  if (paragraphs.length === 0)
    return;
  toastr.success(paragraphs.join('\n'));
}

function error(message: string) {
  toastr.error(message);
}

class ToastrHelperClass {
  readonly success = success;
  readonly error = error;
}

export const toastrHelper = new ToastrHelperClass();
